import { createContext, useContext } from 'react'

export type NavPrefetchContextValue = {
  prefetch: (navId: string) => void
}

export const NavPrefetchContext = createContext<NavPrefetchContextValue>({
  prefetch: () => undefined,
})

export function useNavPrefetch(): (navId: string) => void {
  return useContext(NavPrefetchContext).prefetch
}
